import { useQuery } from '@tanstack/react-query'
import { jsonFetch } from '@/lib/api/jsonFetch'
import type { EmailThread, Signature } from './types'

/**
 * Fetch the email conversation for a record. The `endpoint` is supplied by
 * the consuming page (each domain exposes its own thread route), so this
 * shared hook stays agnostic of which module it serves. Pass `null` to keep
 * the query disabled until an endpoint is known.
 */
export function useEmailThread(endpoint: string | null) {
  return useQuery({
    queryKey: ['email-thread', endpoint],
    queryFn: () => jsonFetch<EmailThread>(endpoint!),
    enabled: !!endpoint,
    staleTime: 30_000,
  })
}

/**
 * Fetch the shared MailDesk signatures available for a record's mailbox. The
 * `endpoint` (e.g. `/api/support/tickets/{id}/signatures`) is supplied by the
 * consuming work-view. Used to populate the response composer's signature
 * picker.
 */
export function useSignatures(endpoint: string | null) {
  return useQuery({
    queryKey: ['email-signatures', endpoint],
    queryFn: () => jsonFetch<{ signatures: Signature[] }>(endpoint!),
    enabled: !!endpoint,
    staleTime: 5 * 60_000,
  })
}
